import {defineStore} from 'pinia';
import type {Product} from "~/types/product";

export const CartTypes = {
    Unknown: 'unknown',
    Regular: 'regular',
    GiftCard: 'giftCard',
    Samaritan: 'samaritan'
}

export interface CartItem {
    uuid: string;
    product: Product;
    storyUUID: string | undefined | null;
}

export const useUserCartStore = defineStore('cart', () => {
    const auth = useAuthStore();
    const items = ref<CartItem[]>([]);
    const isLoaded = ref(false);

    let localStoreName = `itlm-v1-cart-${auth.user?.email}`;

    watch(() => auth.user, (newUser) => {
        if (newUser) {
            localStoreName = `itlm-v1-cart-${newUser.email}`;
            loadFromDisk();
        } else {
            localStoreName = `itlm-v1-cart-undefined`;
            isLoaded.value = false;
            items.value = [];
        }
        console.trace(`Cart store - user session: ${auth.user?.email}`);
    }, {deep: true}); // Use deep: true if you want to detect changes INSIDE the user object

    const addItem = (product: CartItem) => {
        items.value.push(product)
    }

    const removeItem = (uuidToRemove: string) => {
        items.value = items.value.filter(i => i.uuid !== uuidToRemove);
    }

    const clear = () => {
        items.value = [];
    }

    const loadFromDisk = () => {

        const saved = localStorage.getItem(localStoreName);
        if (saved) {
            try {
                items.value = JSON.parse(saved);
            } catch (error) {
                console.error("Failed to parse stories", error);
            }
        }
        isLoaded.value = true;
    }

    const saveStoriesToDisk = () => {
        localStorage.setItem(localStoreName, JSON.stringify(items.value));
    }

    watch(items, () => {
        if (isLoaded.value) {
            saveStoriesToDisk();
        }
    }, {deep: true});

    return {items, addItem, removeItem, loadFromDisk, clear, isLoaded}
});